import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20flatlay%20with%20pastel%20sneakers%20soft%20knit%20sweaters%20and%20delicate%20accessories%20arranged%20in%20airy%20editorial%20composition%20on%20cream%20backdrop%2C%20warm%20natural%20window%20light%20casting%20gentle%20shadows%2C%20clean%20minimal%20aesthetic%2C%20sophisticated%20product%20photography%20with%20muted%20sage%20and%20warm%20sand%20tones%2C%20organic%20textures%2C%20elegant%20spacing%2C%20refined%20lifestyle%20aesthetic&width=1800&height=900&seq=sugargoo-hero-bg-v02&orientation=landscape"
        alt="Sugargoo Spreadsheet fashion product collage"
        title="Sugargoo Spreadsheet - Ultimate Product Database for International Shopping"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl text-white leading-tight tracking-tight">
          Sugargoo Spreadsheet &mdash; The Ultimate Database For Sugargoo Finds, Reviews &amp; Shopping Guides
        </h1>
        <p className="mt-5 md:mt-6 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
          Discover thousands of curated Sugargoo spreadsheet products, updated buying guides, shipping information, discount resources and expert tips in one powerful platform.
        </p>

        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            Sugargoo Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-sm"></i>
            </span>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full text-base font-semibold border-2 border-white/80 text-white hover:bg-white hover:text-foreground-900 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 md:gap-6">
          {[
            "Updated Spreadsheet Database",
            "Beginner Friendly Guides",
            "Shipping Cost Information",
            "Real Shopping Resources",
          ].map((badge) => (
            <span
              key={badge}
              className="inline-flex items-center gap-1.5 text-xs md:text-sm text-white/80"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-check-line text-accent-400 text-sm"></i>
              </span>
              {badge}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}